import React, { useEffect } from "react";

const normalizeProductUsage = (hint, products) => {
  if (!hint) return {};

  const nameToId = {};
  products.forEach(p => {
    if (!p.name) return;
    nameToId[p.name.toLowerCase().trim()] = String(p.id);
  });

  const mapped = {};
  for (const [name, amount] of Object.entries(hint)) {
    const id = nameToId[name.toLowerCase().trim()];
    if (!id) continue;
    mapped[id] = {
      selected: true,
      amount: Number(amount),
    };
  }

  return mapped;
};


export default function AutoLinkIngredientModal({
  isOpen,
  onClose,
  ingredients,
  setIngredients,
  onSave,
  products,
}) {
   // Modal이 열릴 때 product_usage를 정상화한 뒤 렌더되도록 보장
//   useEffect(() => {
//   if (!isOpen) return;

//   setIngredients(prev =>
//     prev.map(item => {
//       const hint = item.product_usage_hint;

//       // GPT 힌트 없으면 그대로
//       if (!hint) return item;

//       const usage = item.product_usage;

//       // 이미 숫자 ID 기반으로 되어 있으면 건드리지 않음
//       if (usage && Object.keys(usage).every(k => !isNaN(Number(k)))) {
//         return item;
//       }

//       // 🔥 여기서 name → id 변환
//       const normalized = normalizeProductUsage(hint, products);
//       return { ...item, product_usage: normalized };
//     })
//   );
// }, [isOpen, products]);
    useEffect(() => {
    if (!isOpen) return;

    setIngredients(prev =>
      prev.map(item => {
        /* =========================
          1️⃣ product_usage 정규화 (기존 로직)
        ========================= */
        let nextItem = item;

        const hint = item.product_usage_hint;
        const usage = item.product_usage;

        if (hint && (!usage || !Object.keys(usage).every(k => !isNaN(Number(k))))) {
          const normalized = normalizeProductUsage(hint, products);
          nextItem = { ...nextItem, product_usage: normalized };
        }

        /* =========================
          2️⃣ 🔥 purchase_count 초기화 (NEW)
          UI 전용 값
        ========================= */
        if (
          nextItem.purchase_quantity &&
          typeof nextItem.estimated_amount === "number"
        ) {
          return {
            ...nextItem,
            _purchase_count:
              nextItem.purchase_quantity > 0
                ? Number(
                    nextItem.estimated_amount / nextItem.purchase_quantity
                  ).toFixed(2)
                : "",
          };
        }

        return nextItem;
      })
    );
  }, [isOpen, products]);
  
  if (!isOpen) return null;



  // 정렬: finished_product 먼저
  const sorted = [...ingredients].sort(
    (a, b) => Number(b.finished_product) - Number(a.finished_product)
  );

  // 특정 ingredient 업데이트 helper
  const updateItem = (id, updates) => {
    setIngredients(prev =>
      prev.map(item =>
        item.id === id ? { ...item, ...updates } : item
      )
    );
  };
  console.log("products in modal", products)
  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-[9999]"
      onClick={onClose}
    >
     
      <div
  className="relative bg-neutral-900 p-6 rounded-xl w-[580px] border border-neutral-700 shadow-xl 
             max-h-[85vh] flex flex-col"
  onClick={(e) => e.stopPropagation()}
>
        <h2 className="text-xl font-semibold mb-4 text-gray-100">
          Suggested Ingredients
        </h2>

        {/* <div className="space-y-4"> */}
        <div className="flex-1 overflow-y-auto max-h-[60vh] pr-2 space-y-4">
          {sorted.map((item) => (
            <div
              key={item.id}
              className={`p-4 border rounded-lg ${
                item.finished_product
                  ? "border-yellow-600 bg-neutral-800/80"
                  : "border-neutral-700 bg-neutral-800"
              }`}
            >
              {/* Row Header */}
              <div className="flex justify-between items-center mb-3">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={item.selected ?? true}
                    onChange={(e) =>
                      updateItem(item.id, { selected: e.target.checked })
                    }
                  />
                  <span
                    className={`font-medium ${
                      item.finished_product
                        ? "text-yellow-300"
                        : "text-gray-200"
                    }`}
                  >
                    {item.name}
                  </span>
                </label>

                <span className="text-xs text-gray-400">
                  {item.recommended_unit || ""}
                </span>
              </div>

              {/* Finished product */}
              {item.finished_product ? (
                <p className="text-xs text-gray-300 italic mb-1">
                  This is a product.
                </p>
              ) : (
                <>
                  {/* Estimated amount input */}
                  <div className="mb-3">
                    <p className="text-xs text-gray-400 mb-1">
                      Estimated Remaining ({item.recommended_unit})
                    </p>
                    <div className="flex items-center gap-2">
                      <input
                        type="number"
                        min="0"
                        value={item.estimated_amount ?? ""}
                        onChange={(e) =>
                          updateItem(item.id, {
                            estimated_amount: Number(e.target.value),
                          })
                        }
                        className="w-24 bg-neutral-900 text-white px-2 py-1 rounded-md border border-neutral-600"
                      />
                      <span className="text-gray-400 text-xs">
                        {item.recommended_unit || ""}
                      </span>
                    </div>
                  </div>
                  {/* 📦 Stock by purchase unit */}
                    <div className="mt-3">
                      <p className="text-xs text-gray-400 mb-1">
                        Stock (by purchase unit)
                      </p>

                      <div className="flex items-center gap-2">
                
                        <input
                          type="number"
                          min="0"
                          step="1"               // ✅ int 단위
                          value={item._purchase_count ?? ""}
                          onChange={(e) => {
                            const raw = e.target.value;
                            const count = raw === "" ? "" : Number(raw);
                            const qty = Number(item.purchase_quantity || 0);

                            updateItem(item.id, {
                              _purchase_count: raw,   // ❗ 그대로 저장 (string 허용)
                              estimated_amount:
                                raw === "" || !qty ? "" : Math.round(qty * count),
                            });
                          }}
                          className="w-24 bg-neutral-900 border border-neutral-600 rounded px-2 py-1 text-sm text-white"
                        />
                        <span className="text-gray-400 text-xs">
                          × {item.purchase_quantity} {item.purchase_unit}
                        </span>
                      </div>
                    </div>
                  {/* Slider */}
                  <div>
                    <p className="text-xs text-gray-400 mb-1">
                      Remaining % ({item.remaining ?? 50}%)
                    </p>
                    
                    <input
                      type="range"
                      min="0"
                      max="100"
                      value={item.remaining_percent ?? 50}
                      onChange={(e) => {
                        const percent = Number(e.target.value);

                        let estimated = item.estimated_amount;

                        // ✅ purchase_quantity 기준으로 자동 계산
                        if (item.purchase_quantity) {
                          estimated = Math.round(
                            (Number(item.purchase_quantity) * percent) / 100
                          );
                        }

                        updateItem(item.id, {
                          remaining_percent: percent,
                          estimated_amount: estimated,
                        });
                      }}
                      className="w-full accent-purple-500"
                    />
                  </div>
                  {/* 💰 Purchase / Cost (from GPT, editable) */}
                  <div className="mt-4 border-t border-neutral-700 pt-3">
                    <p className="text-xs text-gray-400 mb-2">Purchase package</p>

                    <div className="grid grid-cols-3 gap-2">
                      {/* Purchase quantity */}
                      <div>
                        <p className="text-[11px] text-gray-400 mb-1">Quantity</p>
                        <input
                          type="number"
                          min="0"
                          value={item.purchase_quantity ?? ""}
                          onChange={(e) =>
                            updateItem(item.id, {
                              purchase_quantity: Number(e.target.value),
                            })
                          }
                          className="w-full bg-neutral-900 text-white px-2 py-1 rounded border border-neutral-600 text-xs"
                        />
                      </div>

                      {/* Unit */}
                      <div>
                        <p className="text-[11px] text-gray-400 mb-1">Unit</p>
                        <input
                          type="text"
                          value={item.purchase_unit ?? item.recommended_unit ?? ""}
                          onChange={(e) =>
                            updateItem(item.id, {
                              purchase_unit: e.target.value,
                            })
                          }
                          className="w-full bg-neutral-900 text-white px-2 py-1 rounded border border-neutral-600 text-xs"
                        />
                      </div>

                      {/* Total price */}
                      <div>
                        <p className="text-[11px] text-gray-400 mb-1">Total price</p>
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={item.purchase_price ?? ""}
                          onChange={(e) =>
                            updateItem(item.id, {
                              purchase_price: Number(e.target.value),
                            })
                          }
                          className="w-full bg-neutral-900 text-white px-2 py-1 rounded border border-neutral-600 text-xs"
                        />
                      </div>
                    </div>

                    {/* Derived unit cost (read-only) */}
                    <div className="mt-2 text-[11px] text-gray-400">
                      Unit cost:&nbsp;
                      {item.purchase_quantity && item.purchase_price
                        ? (
                            Number(item.purchase_price) /
                            Number(item.purchase_quantity)
                          ).toFixed(4)
                        : "—"}
                      {item.purchase_unit || item.recommended_unit
                        ? ` per ${item.purchase_unit || item.recommended_unit}`
                        : ""}
                    </div>
                  </div>
                      
                      {/* ⭐ Product usage section goes right here! */}
      {/* Product usage section */}
      <div className="mt-4 border-t border-neutral-700 pt-3">
        <p className="text-xs text-gray-400 mb-2">Used in products</p>
        
        {console.log("🔍 Render usage:", item.name, item.product_usage)}
        {/* Already linked products */}
        <div className="space-y-1 mb-2">
            
          {Object.entries(item.product_usage || {}).map(([productId, info]) => {

            console.log("🔎 CHECK RENDER ITEM:", item.name);
            console.log("🔎 productId:", productId);
            console.log("🔎 info:", info);
            console.log("🔎 info.selected:", info?.selected);
            console.log("🔎 products list:", products);
            console.log(
                "🔎 matched product:",
                products.find((p) => String(p.id) === String(productId))
            );
            if (!info || !info.selected) return null;

            const product = products.find(p => String(p.id) === String(productId));
            if (!product) return null;

            return (
              <div
                key={productId}
                className="flex items-center justify-between text-xs bg-neutral-900 px-2 py-1 rounded"
              >
                <span className="text-gray-200">{product.name}</span>
                
                
                {/* <div className="flex items-center gap-2">
                  <span className="text-gray-300">
                    {info.amount} {item.recommended_unit || ""}
                  </span>
                  <button
                    type="button"
                    className="text-red-400 hover:text-red-300"
                    onClick={() => {
                      const nextUsage = { ...(item.product_usage || {}) };
                      delete nextUsage[productId];
                      updateItem(item.id, { product_usage: nextUsage });
                    }}
                  >
                    ✕
                  </button>
                </div> */}
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-1">
                    <input
                      type="number"
                      min="0"
                      value={info.amount}
                      onChange={(e) => {
                        const nextUsage = {
                          ...item.product_usage,
                          [productId]: {
                            ...info,
                            amount: Number(e.target.value),
                          },
                        };
                        updateItem(item.id, { product_usage: nextUsage });
                      }}
                      className="w-16 bg-neutral-900 border border-neutral-600 rounded px-1 text-xs text-white"
                    />
                    <span className="text-gray-400 text-xs">
                      {item.recommended_unit || ""}
                    </span>
                  </div>

                  <button
                    type="button"
                    className="text-red-400 hover:text-red-300"
                    onClick={() => {
                      const nextUsage = { ...(item.product_usage || {}) };
                      delete nextUsage[productId];
                      updateItem(item.id, { product_usage: nextUsage });
                    }}
                  >
                    ✕
                  </button>
                </div>

              </div>
            );
          })}
        </div>

        {/* Add new product usage */}
        <div className="flex items-center gap-2">
          <select
            className="bg-neutral-900 border border-neutral-600 rounded px-2 py-1 text-xs text-gray-200 w-32"
            value={item._newProductId || ""}
            onChange={(e) =>
              updateItem(item.id, { _newProductId: e.target.value })
            }
          >
            <option value="">Select product</option>
            {products.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>

          <input
            type="number"
            min="0"
            className="bg-neutral-900 border border-neutral-600 rounded px-2 py-1 text-xs text-gray-200 w-20"
            placeholder={item.recommended_unit || "amount"}
            value={item._newProductAmount ?? ""}
            onChange={(e) =>
              updateItem(item.id, { _newProductAmount: e.target.value })
            }
          />

          <button
            type="button"
            className="text-xs px-2 py-1 bg-blue-600 hover:bg-blue-500 rounded text-white"
            onClick={() => {
              const productId = item._newProductId;
              const amount = Number(item._newProductAmount);

              if (!productId || !amount) return;

              const currentUsage = item.product_usage || {};
              const updatedUsage = {
                ...currentUsage,
                [productId]: {
                  selected: true,
                  amount,
                },
              };

              updateItem(item.id, {
                product_usage: updatedUsage,
                _newProductId: "",
                _newProductAmount: "",
              });
            }}
          >
            Add
          </button>
        </div>
      </div>
      {/* END Product Usage Section */}


                </>
              )}
            </div>
          ))}
        </div>

        {/* Buttons */}
        <div className="flex justify-end mt-5 gap-3">
          <button
            onClick={onClose}
            className="px-4 py-1.5 bg-gray-700 hover:bg-gray-600 rounded-md text-sm text-gray-200"
          >
            Cancel
          </button>

          <button
            onClick={onSave}
            className="px-4 py-1.5 bg-green-600 hover:bg-green-500 rounded-md text-sm text-white"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}